import { render, staticRenderFns } from "./HenkiloDialog.vue?vue&type=template&id=60d073fc&scoped=true"
import script from "./HenkiloDialog.vue?vue&type=script&lang=js"
export * from "./HenkiloDialog.vue?vue&type=script&lang=js"
import style0 from "./HenkiloDialog.vue?vue&type=style&index=0&id=60d073fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d073fc",
  null
  
)

export default component.exports